<template>
    <div>
        <!-- 库存盘点列表页 -->
        <content-view v-show="$utils.renderWhen(this,'stockTaking')">
            <div slot="header">
                <a-form :form="form" layout="inline">
                    <a-form-item
                    label="仓库名称"
                    >
                        <a-select
                            v-decorator="['warehouseId']"
                            placeholder="请选择"
                            @change="changeStock"
                        >
                            <a-select-option
                            :value="item.id"
                            v-for="(item, index) in wareHouseList"
                            :key="index"
                            >{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="盘点人">
                        <a-input v-decorator="['inventoryUser']" placeholder="请输入"></a-input>
                    </a-form-item>
                    <a-form-item label="盘点日期">
                        <a-range-picker v-decorator="['selectDate']" />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button class="mr8" type="primary" @click="search">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="stock-taking">
                <a-button class="mb16" type="primary" @click="toStockHistory">进行盘点</a-button>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    @change="changePage"
                >
                    <div slot="action" slot-scope="a, row">
                        <router-link class="text-primary" :to="{name: 'checkLogList', query: row}">详情</router-link>
                        <a-divider type="vertical"/>
                        <a-popconfirm
                        :title="`确定删除该记录？`"
                        @confirm="deleteRecord(row.id)"
                        >
                            <a class="text-primary">删除</a>
                        </a-popconfirm>
                    </div>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from 'moment';
    import { mapGetters } from "vuex";
    export default {
        name: 'stockTaking',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '编号',
                    dataIndex: 'id'
                },
                {
                    title: '盘点日期',
                    dataIndex: 'inventoryTime'
                },
                {
                    title: '盘点人',
                    dataIndex: 'inventoryUser'
                },
                {
                    title: '仓库名称',
                    dataIndex: 'warehouseName'
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: {
                        customRender: 'action'
                    }
                }
            ];
            return {
                form: this.$form.createForm(this),
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                wareHouseList: [],
                storageId: ''
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset() {
                    this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const rangeValue = values['selectDate'] ? values['selectDate'] : []
                    values.shopId = this.shopId
                    values.inventoryTimeStart = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD 00:00:00') : null
                    values.inventoryTimeEnd = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD 23:59:59') : null
                    delete values.selectDate
                    this.$api.storage
                    .inventoryList({
                        body: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                        this.getWarehouseList();
                    });
                });
            },
            confirmStock() {
                var params = {
                    id: this.chosedIndex,
                    num: this.stocking,
                    remark: this.remark
                };
                this.$api.storage.inventoryChanges({ body: params }).then(res => {
                    this.changeStockVisible = false;
                    this.inventoryList();
                });
            },
            //仓库列表
            getWarehouseList() {
                this.$api.storage.getWarehouseList({params: {
                    shopId: this.shopId
                }}).then(res => {
                    this.wareHouseList = res;
                });
            },
            // 选择仓库
            changeStock(e) {
                this.storageId = e;
            },
            // 跳转到去盘点页面
            toStockHistory() {
                this.$router.push({ name: 'stockTakeHistory'});
            },
            // 删除
            deleteRecord(id) {
                this.$api.storage.delInventoryLog({ params: { id: id } }).then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                });
            }
        },
        created() {},
        mounted() {
            this.getList()
        },
        watch: {
            '$route'(val) {
                val.name == 'stockTaking' && this.getList();
            },
            'shopId'() {
                this.getList()
            }
        }
    };
</script>
<style lang="scss">
    .stock-taking {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
    }
</style>